import type { Column } from '@tanstack/react-table';
import { type ReactNode, useMemo } from 'react';
import { DataTableHeaderCell } from '../../_base/index.js';
import { DataTableHeaderCellSurface } from '../../_base/surface/index.js';
import { useOpenPopover } from '../../_hooks/open-popover.js';
import { ResetFilterMenuItem } from '../../_shared/reset.js';
import { SelectFilter } from './filter.js';

type DataTableHeaderCellSelectProps<TData, TValue> = {
    column: Column<TData, TValue>;
    title: ReactNode;
    tooltip: ReactNode;
};

export function DataTableHeaderCellSelect<TData, TValue>({
    column,
    title,
    tooltip,
}: DataTableHeaderCellSelectProps<TData, TValue>) {
    const { open, openPopover, closePopover, onOpenChange } = useOpenPopover();

    const filter = column.columnDef.meta?.filter;

    const safeOptions = useMemo(() => {
        if (filter?.type !== 'select') {
            return [];
        }

        return filter.options;
    }, [filter]);

    return (
        <DataTableHeaderCell
            column={column}
            title={title}
            open={open}
            openPopover={openPopover}
            closePopover={closePopover}
            onOpenChange={onOpenChange}
            tooltip={tooltip}
            popover={
                <DataTableHeaderCellSurface
                    column={column}
                    closePopover={closePopover}
                    filterNode={
                        <>
                            <ResetFilterMenuItem column={column} closePopover={closePopover} />

                            <SelectFilter column={column} options={safeOptions} />
                        </>
                    }
                />
            }
        />
    );
}
